import React from 'react';
import { CreditCard, Mail } from 'lucide-react';
import { CONTACT_EMAIL_HREF, INSTAGRAM_URL } from '../data/contact';
import { useLanguage } from '../contexts/LanguageContext';
const AMOUNTS = [25, 50, 75, 100];
export function GiftCardSection() {
  const {
    t
  } = useLanguage();
  return <section id="carte-cadeau" className="scroll-mt-32 bg-cacao-900 py-24 md:py-28" data-id="element-94" data-mp="1nbi7ibblxxee">
      <div className="mx-auto max-w-4xl px-6 text-center md:px-12" data-id="element-95" data-mp="19bhax82dlc4q">
        <span className="mb-6 inline-flex items-center gap-2 border border-or/40 px-4 py-1.5 font-sans text-[10px] uppercase tracking-[0.2em] text-caramel-light" data-id="element-96" data-mp="19ed98xi4y2tp">
          <CreditCard size={13} strokeWidth={1.75} aria-hidden="true" data-id="element-97" data-mp="zf4fa4n9so7c" />
          {t.giftCard.eyebrow}
        </span>

        <h2 className="mb-6 font-serif text-3xl text-creme md:text-4xl" data-id="element-98" data-mp="14d5ziswfmtke">
          {t.giftCard.titleLead}{' '}
          <span className="italic text-caramel-light" data-id="element-99" data-mp="2tprfnsda1m59">
            {t.giftCard.titleAccent}
          </span>
        </h2>
        <p className="mx-auto mb-10 max-w-2xl font-sans font-light leading-relaxed text-creme/80" data-id="element-100" data-mp="3jsx62cl63x5d">
          {t.giftCard.intro}
        </p>

        <p className="mb-4 font-sans text-[10px] uppercase tracking-[0.2em] text-or" data-id="element-101" data-mp="3etar9ypoy8ug">
          {t.giftCard.amountsLabel}
        </p>
        <ul className="mb-10 flex flex-wrap justify-center gap-4" data-id="element-102" data-mp="3snlda8aazowt">
          {AMOUNTS.map(amount => <li key={amount} className="border border-or/40 px-7 py-4 font-serif text-xl text-creme" data-id="element-103" data-mp="3om9jdqkechit">
              {amount} $
            </li>)}
        </ul>

        <div className="mb-8 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-104" data-mp="39uzizsf1o6ec">
          <a href={CONTACT_EMAIL_HREF} className="flex items-center gap-3 bg-caramel px-8 py-4 font-sans text-xs uppercase tracking-[0.16em] text-creme transition-colors duration-300 hover:bg-caramel-light" data-id="element-105" data-mp="34vwc02fi7q3q">
            <Mail size={15} strokeWidth={1.5} aria-hidden="true" data-id="element-106" data-mp="k4nj85gma5cf" />
            {t.giftCard.cta}
          </a>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="border border-caramel-light px-8 py-4 font-sans text-xs uppercase tracking-[0.16em] text-caramel-light transition-colors duration-300 hover:border-creme hover:text-creme" data-id="element-107" data-mp="3dwvkicax9l3m">
            {t.events.dmCta}
          </a>
        </div>

        <p className="mx-auto max-w-xl font-sans text-sm font-light text-creme/65" data-id="element-108" data-mp="2v7ynw1s1ygi8">
          {t.giftCard.note}
        </p>
      </div>
    </section>;
}